// extracted by mini-css-extract-plugin
module.exports = {"container":"Section7_container__LstTR","content":"Section7_content__DVtPD","headline":"Section7_headline__GOZEY","subHeadline":"Section7_subHeadline__fvMtW"};